module.exports = "<i *ngFor=\"let r of rates\" class=\"fa\"\n[class.fa-star]=\"r <= rate\" [class.fa-star-o]=\"r > rate\"\n(click)=\"setRate(r)\"\n(mouseenter)=\"setTemporaryRate(r)\"\n(mouseleave)=\"clearTemporaryRate()\"></i>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/rating/rating.component.html
// module id = 382
// module chunks = 2